<template>
    <div id="answer">
        <div class="app-container mb-5" v-if="!$global.loading">

            <!-- Titre -->
            <div class="d-flex justify-content-between align-items-center">
                <div class="page-title mb-5 mt-5">
                    Informations à valider
                </div>
            </div>

            <div class="container-fluid">
                <div class="row">
                    <!-- Contexte -->
                    <v-card class="mb-5 mr-4 col">
                        <div class="p-4">
                            <h5 class="mb-5">Informations du répondant</h5>

                            <div class="d-flex justify-content-between align-items-center mb-5">
                                <router-link :to="'/summary/' + getB64(provider.provider.id)">
                                    <h5 class="m-0">{{ provider.name }}</h5>
                                </router-link>
                            </div>
                            <div>
                                <p class="mb-4" v-if="campaign !== null">
                                    Campagne
                                    <span v-if="campaign.aspect">
                                        {{ aspectLabel }}
                                    </span>
                                    <router-link :to="'/campaign/cmaj/' + getB64(campaign.id)">{{ campaign.name }}
                                    </router-link>
                                </p>

                                <p class="mb-4">
                                    Réponse de <b>{{ answer.first_name }} {{ answer.last_name }}</b> (<a
                                  :href="'mailto:' + answer.email + '?subject=Au sujet de ' + provider.name">{{
                                        answer.email
                                    }}</a>)
                                </p>

                                <p class="mb-4">
                                    Reçue le {{ formatDate(answer.updated_at) }} — <a class="mt-2"
                                                                                      :href="apiUrl + '/export-to-pdf/cmaj/' + answer.id + '/' + selectLast">
                                    Télécharger le PDF
                                </a>
                                </p>

                                <div class="mt-5 pt-5 text-center">
                                    <v-btn class="default-button" @click="saveBeforeTreat"
                                           v-if="account.tis_type.code === 'DAHUB_QUEBEC'">
                                        Marquer la réponse comme traitée
                                    </v-btn>
                                    <v-btn class="default-button" @click="treatAnswer" v-else>
                                        Marquer la réponse comme traitée
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card>

                    <!-- Options MAJ apidae -->
                    <v-card class="mb-5 col">
                        <div class="mr-auto ml-auto p-4 bg-white rounded mb-5">
                            <div class="d-">
                                <h5 class="mb-5" v-if="account.tis_type.code === 'APIDAE'">Mise à jour Apidae</h5>
                                <h5 class="mb-5" v-if="account.tis_type.code === 'TOURINSOFT'">Mise à jour
                                    Tourinsoft</h5>
                                <h5 class="mb-5" v-if="account.tis_type.code === 'DAHUB_QUEBEC'">Mise à jour
                                    Hawwwai</h5>

                                <div class="d-flex">
                                    <div class="mt-auto mb-auto"
                                         v-if="provider.source && provider.source.type === 'APIDAE'">
                                        Numéro Apidae: {{ provider.source.external_id }}
                                    </div>
                                    <div class="mt-auto mb-auto"
                                         v-else-if="provider.source && provider.source.type === 'TOURINSOFT'">
                                        Numéro Tourinsoft: {{ provider.source.external_id }}
                                    </div>
                                    <div v-if="provider.source && provider.source.type === 'APIDAE'">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" icon target="_blank"
                                                       :href="provider.source.url">
                                                    <v-icon>open_in_new</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Voir sur Apidae</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2" v-if="criterias.length">
                                <div class="d-flex">
                                    <p class="mb-2">Critères internes :</p>
                                    <v-tooltip slot="append-outer" bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon class="align-baseline">
                                                <v-icon>help</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                Assurez vous d’avoir au préalable ajouté Dahub<br>
               en tant que Membre collaborateur de vos critères internes sur Apidae.
                            </span>
                                    </v-tooltip>
                                </div>
                                <v-autocomplete :items="criterias" chips deletable-chips style="background-color: white"
                                                label="Sélectionner vos critères internes" item-text="libelle"
                                                item-value="id" hide-details
                                                v-model="selectedCriterias" multiple outlined>
                                </v-autocomplete>
                            </div>

<!--                            <div class="mb-2" v-if="account.tis_type.code === 'APIDAE'">-->
<!--                                <v-checkbox style="padding-top: 0 !important;" hide-details v-model="multiHours"-->
<!--                                            label="Mettre à jour les horaires directement dans le module Multi-horaires">-->
<!--                                </v-checkbox>-->
<!--                            </div>-->

                            <!--Actions-->
                            <div>
                                <div class="mt-auto text-center">
                                    <div v-if="account.tis_type.code === 'APIDAE'" class="text-center">
                                        <div v-if="lastWrite !== null" class="last-write">Dernière mise à jour Apidae le
                                            {{ lastWrite }}
                                        </div>
                                        <v-btn class="default-button"
                                               :disabled="!hasToken || !canWrite || !answer.open_this_season || is404Source"
                                               @click="writeTis">
                                            Faire une demande de brouillon sur Apidae
                                        </v-btn>
                                    </div>

                                    <div v-else-if="account.tis_type.code === 'TOURINSOFT'" class="text-center mt-2">
                                        <div v-if="lastWrite !== null" class="last-write">Dernière mise à jour
                                            Tourinsoft le {{ lastWrite }}
                                        </div>
                                        <div v-if="hasVtContractAndMissingLocalisation">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on">
                                                        <v-btn class="default-button" disabled>
                                                            Envoyer sur Tourinsoft
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <span>
                                                    Une adresse et une commune doivent-être renseignée pour envoyer la
                                                    donnée sur Tourinsoft
                                                </span>
                                            </v-tooltip>
                                        </div>

                                        <div class="mt-3" v-else>
                                            <v-btn class="default-button" @click="writeTis">
                                                Envoyer sur Tourinsoft
                                            </v-btn>
                                        </div>
                                    </div>

                                    <div v-else class="text-center mt-2">
                                        <div v-if="lastWrite !== null" class="last-write">Dernière mise à jour
                                            Hawwwai le {{ lastWrite }}
                                        </div>
                                        <div class="mt-3">
                                            <v-btn class="default-button" @click="writeTis">
                                                Envoyer sur Hawwwai
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>

            <!-- Erreurs & warnings -->
            <div class="mb-5">
                <v-alert type="error" text v-if="!hasToken">
                    Votre connexion avec Apidae a expirée. Merci de vous reconnecter pour pouvoir utiliser le
                    service d'écriture Apidae.
                    <div class="text-center mt-3 mb-3">
                        <v-btn class="default-button" @click="loginAgain">Me reconnecter</v-btn>
                    </div>
                </v-alert>

                <v-alert type="warning" text v-if="is404Source">
                    La fiche n'existe pas sur {{ account.tis_type.code === "APIDAE" ? "Apidae" : "Tourinsoft" }}.
                    <div class="w-100 text-center mt-4">
                        <v-btn color="warning" @click="writeTis">
                            Créer la fiche sur {{ account.tis_type.code === "APIDAE" ? "Apidae" : "Tourinsoft" }}
                        </v-btn>
                    </div>
                </v-alert>

                <v-alert type="error" text v-else-if="!canWrite">
                    Vous ne disposez pas des droits nécéssaires pour écrire sur cette fiche APIDAE.
                </v-alert>

                <div v-if="!answer.open_this_season">
                    <v-alert type="warning" text>
                        Le prestataire déclare avoir cessé cette activité.
                    </v-alert>
                </div>

                <div v-if="hasManyAnswers">
                    <v-alert type="warning" text v-if="selectLast">
                        Cette réponse n'est pas la réponse originale du prestataire.
                        <v-btn class="default-button ml-3" @click="switchVersion">Voir la réponse originale</v-btn>
                    </v-alert>

                    <v-alert type="success" text v-else>
                        Cette réponse a été modifiée le <b>{{ lastModification }}</b>.
                        <v-btn class="default-button ml-3" @click="switchVersion">Voir la réponse modifiée</v-btn>
                    </v-alert>
                </div>

                <div v-if="forbiddenThematisedDesc.length > 0">
                    <v-expansion-panels class="p-0">
                        <v-expansion-panel>
                            <v-alert type="error" text class="h-100">
                                <v-expansion-panel-header style="padding: 0 !important; font-size: 16px !important;">
                                    <span>La réponse contient des éléments rendus incompatibles entre eux par Apidae.
                                    Cela va empêcher le bon fonctionnement de l'écriture vers Apidae. <br><br>
                                    Nous vous recommandons de vider le(s) champ(s) concerné(s) en mettant le contenu
                                        dans un autre champ ou de retirer l'élément posant problème avant de lancer
                                        votre écriture.</span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="mt-3">
                                    <ul v-for="desc in forbiddenThematisedDesc">
                                        <li>Le champ {{ displayThematisedDescLabel(desc.code) }} est incompatible avec
                                            les éléments
                                            <ul v-for="blockingElement in desc.blockingElements">
                                                <li>{{ blockingElement }}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </v-expansion-panel-content>
                            </v-alert>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>

            <!-- Infos complémentaires -->
            <div class="p-4 bg-white rounded mr-auto ml-auto mb-5" v-if="answer.extra !== null && answer.extra !== ''">
                <h5>Informations complémentaires</h5>

                <v-textarea class="textarea extra-area" style="background-color: white" readonly v-model="answer.extra"
                            outlined>
                </v-textarea>
            </div>

            <!-- Réponse complète -->
            <div class="p-4 mb-5 bg-white rounded mr-auto ml-auto" v-if="answer.open_this_season">
                <div v-if="answer.open_this_season">
                    <general :languages="languages" class="mt-5"></general>

                    <private-descriptifs :languages="languages"></private-descriptifs>

                    <localisation></localisation>

                    <contacts :contacts="contacts"></contacts>

                    <medias class="mt-5"></medias>

                    <specific class="mt-5"></specific>

                    <opening-hours></opening-hours>

                    <price-periods class="mt-5"></price-periods>

                    <capacities class="mt-5"></capacities>

                    <handicapped :languages="languages" class="mt-5"></handicapped>

                    <room-renting class="mt-5"></room-renting>

                    <covid></covid>

                    <apidae-contacts :professions="professions"></apidae-contacts>
                </div>
            </div>

            <!-- Retour en haut -->
            <div id="up-scroll" @click="scrollTop">
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-icon class="white--text">keyboard_arrow_up</v-icon>
                        </span>
                    </template>
                    <span>Retour en haut</span>
                </v-tooltip>
            </div>
        </div>

        <div v-if="!$global.loading && errorMessage !== null" class="mt-5 mb-5 app-container">
            <v-alert type="error" text border="right" colored-border>
                {{ errorMessage }}
            </v-alert>
        </div>

    </div>
</template>

<script>
import Covid from "./tabulations/Covid"
import { mapGetters, mapMutations, mapState } from "vuex"
import General from "./tabulations/General"
import Handicapped from "./tabulations/Handicapped"
import Localisation from "./tabulations/Localisation"
import Contacts from "./tabulations/Contacts"
import Medias from "./tabulations/Medias"
import Specific from "./tabulations/Specific"
import Capacities from "./tabulations/Capacities"
import RoomRenting from "./tabulations/RoomRenting"
import OpeningHours from "./tabulations/OpeningHours"
import PricePeriods from "./tabulations/PricePeriods"
import hash from "object-hash"
import _ from "lodash"
import ApidaeContacts from "./tabulations/ApidaeContacts"
import PrivateDescriptifs from "./tabulations/PrivateDescriptifs.vue"
import { aspectElements, thematisedDescCodeConnection } from "../../static/webform"

export default {
    name: "Answer",
    components: {
        PrivateDescriptifs,
        ApidaeContacts,
        PricePeriods,
        OpeningHours,
        RoomRenting, Capacities, Specific, Medias, Contacts, Localisation, General, Handicapped, Covid,
    },
    data() {
        return {
            token: null,
            answer: null,
            provider: null,
            baseProviderHash: null,
            contacts: [],
            languages: [],
            professions: [],
            hasToken: true,
            canWrite: true,
            apiUrl: process.env.VUE_APP_API_URL,
            isDirty: false,
            lastWrite: null,
            lastModification: null,
            selectLast: false,
            campaign: null,
            hasManyAnswers: false,
            errorMessage: null,
            selectedMode: 1,
            is404Source: false,
            criterias: [],
            selectedCriterias: [],
            closureDescription: true,
        }
    },
    methods: {
        ...mapMutations("web_form", [
            "resetState", "setProvider", "setFields", "setDisabled", "setFamilyElements", "setExtra",
            "setCapacities", "setRoomRenting", "setCurrencies", "setCategoryFamilies", "setThematisedDescCriterias",
            "updateForbiddenThematisedDesc", 'setSourcesLoaded',
        ]),
        getAnswer() {
            this.$global.loading = true

            this.baseProviderHash = null
            this.isDirty = null

            this.$http.get("webform/answer/" + this.token + "/" + this.selectLast).then(res => {
                if (res.body.success) {
                    let provider = res.body.data.provider

                    this.answer = res.body.data.answer
                    this.hasToken = res.body.data.hasToken
                    this.canWrite = res.body.data.canWrite
                    this.campaign = res.body.data.campaign
                    this.hasManyAnswers = res.body.data.hasManyAnswers
                    this.is404Source = res.body.data.is404Source

                    let lastWriteAction = res.body.data.lastWriteAction
                    let lastModificationAction = res.body.data.lastModificationAction

                    if (lastWriteAction !== null) {
                        this.lastWrite = this.$moment(lastWriteAction.pivot.created_at).format("DD-MM-YYYY à HH[h]mm")
                    }

                    if (lastModificationAction !== null) {
                        this.lastModification = this.$moment(lastModificationAction.pivot.created_at).format("DD-MM-YYYY à HH[h]mm")
                    }

                    this.formatProviderData(provider)

                    this.setProvider(provider)
                    this.setFields(res.body.data.fields)
                    this.setFamilyElements(res.body.data.referential)
                    this.setExtra(this.answer.extra)
                    this.setRoomRenting(res.body.data.provider.room_renting)
                    this.setCategoryFamilies(res.body.data.categoryFamilies)

                    let capacities = this.getFamilyByCode("Capacites")

                    this.setCapacities(capacities)
                    this.setSourcesLoaded(true)

                    this.provider = provider

                    if (this.campaign !== null && this.campaign !== undefined) {
                        this.selectedCriterias = this.campaign.apidae_criterias.map(criteria => criteria.external_id)
                    }

                    if (this.account.tis_type.code === "APIDAE") {
                        this.getThematisedDescCriterias()
                    }

                    document.title = "Dahub – " + this.provider.name

                    this.$global.loading = false
                } else if (res.body.code === 404) {
                    this.errorMessage = "La fiche n'existe plus sur Dahub. Elle a du être supprimée depuis le tableau" +
                      " des prestataires. La réponse associée à cette fiche n'est donc plus disponible."

                    this.$global.loading = false
                    this.loaded = true
                }
            })
        },
        formatProviderData(provider) {
            this.formatPricePeriods(provider)
        },
        formatPricePeriods(provider) {
            provider.price_periods.forEach(period => {
                period.prices.forEach(price => {
                    let mode = "MIN_MAX"

                    if (price.min === price.max) {
                        mode = "UNIQUE"
                    } else if (price.max === null) {
                        mode = "FROM"
                    }

                    price.min = price.min / 100
                    price.max = price.max / 100

                    price.mode = mode
                })
            })
        },
        getCommunicationTypes() {
            this.$http.get("resource/communication-types").then(res => {
                this.contacts = res.body.data.contacts
            })
        },
        writeTis() {
            this.$forceUpdate()

            this.$global.loading = true
            this.selectLast = true

            setTimeout(() => {
                if (this.isDirty) {
                    this.saveAndWrite()
                } else {
                    if (this.account.tis_type.code === "DAHUB_QUEBEC") {
                        this.callHawwai()
                    } else {
                        this.write()
                    }
                }
            }, 500)
        },
        callHawwai() {
            let payload = {
                provider: this.provider.provider.id,
            }

            this.$http.post("auth/answers/write/hawwwai", payload).then(res => {
                this.$global.loading = false

                this.$store.dispatch("account/getUskaNotificationsCount")
            })
        },
        saveBeforeTreat() {
            this.$forceUpdate()

            this.$global.loading = true
            this.selectLast = true

            setTimeout(() => {
                if (this.isDirty) {
                    this.saveAndTreat()
                } else {
                    this.treatAnswer()
                }
            }, 500)
        },
        saveAndWrite() {
            let provider = JSON.parse(JSON.stringify(this.provider))

            provider = this.fixData(provider)

            let payload = {
                answerId: this.answer.id,
                provider: this.provider,
                aspect: this.campaign ? this.campaign.aspect : null
            }

            this.$http.post("auth/answers/save", payload).then(res => {
                if (res.body.success) {
                    this.provider.id = res.body.data.lastVersion.id

                    if(this.account.tis_type.code === "DAHUB_QUEBEC") {
                        this.callHawwai()
                    } else {
                        this.write()
                    }

                    this.getAnswer()
                    this.getCommunicationTypes()
                    this.getLanguages()
                    this.getProfessions()
                    this.getCurrencies()
                }
            })
        },
        saveAndTreat() {
            let provider = JSON.parse(JSON.stringify(this.provider))

            provider = this.fixData(provider)

            let payload = {
                answerId: this.answer.id,
                provider: this.provider,
            }

            this.$http.post("auth/answers/save", payload).then(res => {
                if (res.body.success) {
                    this.provider.id = res.body.data.lastVersion.id
                    this.treatAnswer()

                    this.getAnswer()
                    this.getCommunicationTypes()
                    this.getLanguages()
                    this.getProfessions()
                    this.getCurrencies()
                }
            })
        },
        write() {
            let payload = {
                answerId: this.answer.id,
                providerDataId: this.provider.id,
                skipSso: false,
                criterias: this.selectedCriterias,
                closureDescription: this.closureDescription,
            }

            let tis = this.account.tis_type.code === "APIDAE" ? "apidae" : "tourinsoft"

            if (this.account.tis_type.code === "DAHUB_QUEBEC") {
                tis = "quebec"
            }

            this.$http.post("auth/answers/write/" + tis, payload).then(res => {
                this.$global.loading = false

                this.$store.dispatch("account/getUskaNotificationsCount")
            })
        },
        loginAgain() {
            window.location.href = this.apiUrl + "/sso/attempt/" + btoa(window.location.href)
        },
        getLanguages() {
            this.$http.get("resource/languages").then(res => {
                this.languages = res.body.data.languages
            })
        },
        getProfessions() {
            this.$http.get("resource/professions").then(res => {
                this.professions = res.body.data.professions
            })
        },
        getCurrencies() {
            this.$http.get("resource/currencies").then(res => {
                this.setCurrencies(res.body.data.currencies)
            })
        },
        getInternalCriterias() {
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
        fixData(provider) {
            if (provider.localisation.commune !== undefined && provider.localisation.commune !== null) {
                provider.localisation.commune_id = provider.localisation.commune.id
            }

            provider.capacities = this.capacities.filter(capacity => {
                return capacity.value !== undefined && capacity.value !== ""
            })

            provider.room_renting = this.roomRenting

            provider.price_periods.forEach(period => {
                period.prices.map(price => {
                    if (price.mode === "UNIQUE") {
                        price.max = price.min
                    } else if (price.mode === "FROM") {
                        price.max = null
                    }
                })
            })

            if (provider.room_renting !== undefined) {
                provider.room_renting.rooms.forEach(room => {
                    if (room.area !== null) {
                        room.area = room.area.toString().replace(",", ".")
                    }
                })
            }

            return provider
        },
        getB64(id) {
            return btoa(id)
        },
        switchVersion() {
            this.selectLast = !this.selectLast

            this.getAnswer()
        },
        treatAnswer() {
            this.$global.loading = true

            this.$http.get("auth/webform/treat/answer/" + this.answer.id).then(res => {
                this.answer.web_form.state = res.body.data.state

                this.$store.dispatch("account/getUskaNotificationsCount")

                this.$global.loading = false
            })
        },
        hasAddressFieldWithNoData() {
            return this.hasField("ADDRESS") &&
              (this.provider.localisation.commune === null || this.provider.localisation.commune === "")
        },
        hasCityFieldWithNoData() {
            return this.hasField("CITY") &&
              (this.provider.localisation.address === null || this.provider.localisation.address === "")
        },
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
        },
        getThematisedDescCriterias() {
            this.$global.loading = true

            this.$http.get("auth/answers/thematised-desc-criterias").then(res => {
                this.setThematisedDescCriterias(res.body.data.criterias)
                this.updateForbiddenThematisedDesc()

                this.$global.loading = false
            })
        },
        displayThematisedDescLabel(code) {
            return thematisedDescCodeConnection.find(desc => desc.code === code).label
        },
    },
    computed: {
        ...mapState("web_form", ["capacities", "thematisedDescCriterias", "forbiddenThematisedDesc"]),
        ...mapState("account", ["account", "vtContract"]),
        ...mapGetters("web_form", ["hasField", "hasFamilyElement", "getFamilyByCode", "getElementsByFamilyCode"]),
        hasVtContractAndMissingLocalisation() {
            return this.vtContract && (this.hasAddressFieldWithNoData() || this.hasCityFieldWithNoData())
        },
        aspectLabel() {
            if(this.aspect !== undefined && this.aspect !== '') {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).label
            }
        },
    },
    mounted() {
        if (localStorage.closureDescription && (localStorage.closureDescription === "false" || localStorage.closureDescription === false)) {
            this.closureDescription = false
        } else if (localStorage.closureDescription && (localStorage.closureDescription === "true" || localStorage.closureDescription === true)) {
            this.closureDescription = true
        }
    },
    watch: {
        provider: {
            handler: _.debounce(function() {
                if (this.baseProviderHash === null) {
                    this.baseProviderHash = hash(this.provider)
                }

                this.isDirty = this.baseProviderHash !== hash(this.provider)
            }, 500),
            deep: true,
        },
        closureDescription(value) {
            localStorage.closureDescription = value
        },
    },
    created() {
        this.token = this.$route.params.token

        this.resetState()
        this.setDisabled(true)
        this.getInternalCriterias()

        this.getAnswer()
        this.getCommunicationTypes()
        this.getLanguages()
        this.getProfessions()
        this.getCurrencies()
    },
}
</script>
